<template>
    <div>
    </div>
</template>

<script>
import { GoogleAnalyticsOAuthService, ErrorService } from '@/main'
import notification from '@/mixins/notification';
import * as Sentry from "@sentry/browser"

export default {
    name: "GAoauthLoading",
    mixins: [notification],
    methods: {
        async connectGoogle(code) {
            const websiteId = $cookies.get('website_id')
            try {
                const res = await GoogleAnalyticsOAuthService.connectGoogle(code, websiteId)
                if (!res) {
                    return
                }
                this.$router.push({ path: `/connect-integration/${websiteId}` })
            } catch(e) {
                this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                Sentry.captureException(e)
                console.log(e)
            }
        },
    },
        mounted() {
            this.connectGoogle(this.$route.query.code)
    }
}
</script>
